module.exports = "/static/Images/en/Four.png";